export default {
	SET_BALANCE(state, balance) {
		state.balance = balance
	},
	SET_PIN(state, pin) {
		state.pin = pin
	}
}